import * as Sentry from '@sentry/react'
import config from './config'
import packageInfo from '../package.json'

Sentry.init({
	dsn: config.logging.sentryDSN,
	sendDefaultPii: true,
	integrations: [
		Sentry.browserTracingIntegration(),
		Sentry.browserProfilingIntegration(),
		Sentry.replayIntegration(),
	],
	sampleRate: 1.0,
	tracesSampleRate: 1.0,
	replaysSessionSampleRate: 0.1,
	replaysOnErrorSampleRate: 1.0,
	release: packageInfo.version,
})
